import React from "react";
import "./app.styles.scss";
import { messageAppService } from "./app/message";
import { MessageEventTypes } from "./app/message/shared/events";
import { IChatBoxListUIController, ChatBoxListUIController } from "./ui/core/controllers";
import { ChatBoxViewProvider, ChatBoxListProvider } from "./ui/contexts";
import { SnapEffectContainer } from "./ui/core/animations";
import { ChatBoxWindow } from "./ui/components/ChatBoxWindow";
import { ChatBoxView } from "./ui/components/ChatBoxView";
import { SelectableChatBoxListProvider } from "./ui/components/SelectableChatBoxList";
import { LogView } from "./ui/components/LogView";

function App() {
	const MaiHoangDiepAnh = React.useMemo(
		() => ({
			uid: "maihoangdiepanh",
			name: "Mai Hoàng Diệp Anh",
			avatarUrl: require("./assets/images/mai-hoang-diep-anh-ava-500.jpg"),
			accessTimeInfo: "Truy cập 3 phút trước",
		}),
		[],
	);
	const MaiTrungDong = React.useMemo(
		() => ({
			uid: "maitrungdong",
			name: "Mai Trung Đông",
			avatarUrl: require("./assets/images/mai-trung-dong-ava-500.png"),
			accessTimeInfo: "Vừa mới truy cập",
		}),
		[],
	);
	const MHDAChatBoxListUIcontroller = React.useMemo<IChatBoxListUIController>(() => {
		const controller = new ChatBoxListUIController(MaiHoangDiepAnh.uid);
		(window as any).MHDAChatBoxListUIcontroller = controller;
		return controller;
	}, [MaiHoangDiepAnh.uid]);
	const MTDChatBoxListUIcontroller = React.useMemo<IChatBoxListUIController>(() => {
		const controller = new ChatBoxListUIController(MaiTrungDong.uid);
		(window as any).MTDChatBoxListUIcontroller = controller;
		return controller;
	}, [MaiTrungDong.uid]);
	React.useEffect(() => {
		return messageAppService.addEventListener(MessageEventTypes.ReceiveNewMessage, (event) => {
			MHDAChatBoxListUIcontroller.onReceiveNewMessage(event.message);
			MTDChatBoxListUIcontroller.onReceiveNewMessage(event.message);
		});
	}, [MHDAChatBoxListUIcontroller, MTDChatBoxListUIcontroller]);

	const ChatBoxWindowWidth = 560;
	const ChatBoxWindowHeight = 720;

	return (
		<div className="app">
			<ChatBoxViewProvider fromUidInfo={MaiHoangDiepAnh} toUidInfo={MaiTrungDong}>
				<ChatBoxListProvider controller={MTDChatBoxListUIcontroller}>
					<SelectableChatBoxListProvider>
						<ChatBoxWindow
							windowId="1"
							windowName={`Chat Box Window (${MaiHoangDiepAnh.name})`}
							windowWidth={ChatBoxWindowWidth}
							windowHeight={ChatBoxWindowHeight}
							initialPosition={{
								x: (window.innerWidth - 2 * ChatBoxWindowWidth) / 3,
								y: window.innerHeight / 2 - ChatBoxWindowHeight / 2,
							}}
						>
							<ChatBoxView scrollerElementId="chat-box-list-view-1" />
						</ChatBoxWindow>
					</SelectableChatBoxListProvider>
				</ChatBoxListProvider>
			</ChatBoxViewProvider>
			<ChatBoxViewProvider fromUidInfo={MaiTrungDong} toUidInfo={MaiHoangDiepAnh}>
				<ChatBoxListProvider controller={MHDAChatBoxListUIcontroller}>
					<SelectableChatBoxListProvider>
						<ChatBoxWindow
							windowId="2"
							windowName={`Chat Box Window (${MaiTrungDong.name})`}
							windowWidth={ChatBoxWindowWidth}
							windowHeight={ChatBoxWindowHeight}
							initialPosition={{
								x: (2 * window.innerWidth - ChatBoxWindowWidth) / 3,
								y: window.innerHeight / 2 - ChatBoxWindowHeight / 2,
							}}
						>
							<ChatBoxView scrollerElementId="chat-box-list-view-2" />
						</ChatBoxWindow>
					</SelectableChatBoxListProvider>
				</ChatBoxListProvider>
			</ChatBoxViewProvider>
			<LogView />
			<SnapEffectContainer />
		</div>
	);
}

export default App;
